(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bestseller-spotlight"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBsp(root) {
    var rail = root.querySelector('.bsp__rail');
    if (!rail) return;
    var cards = Array.prototype.slice.call(root.querySelectorAll('.bsp-card'));
    if (!cards.length) return;
    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (c) { c.classList.add('is-active'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          cards.forEach(function (c) { c.classList.remove('is-active'); });
          e.target.classList.add('is-active');
        }
      });
    }, { root: rail, rootMargin: '0px -45% 0px -45%', threshold: 0 });
    cards.forEach(function (c) { io.observe(c); });
  }
  function boot() {
    document.querySelectorAll('.bsp').forEach(initBsp);
  }
  if (document.readyState !== 'loading') { boot(); }
  else { document.addEventListener('DOMContentLoaded', boot); }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('.bsp') : null;
    if (root) initBsp(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-launch-v2"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.alhv2').forEach((hero) => {
  const stage = hero.querySelector('[data-stage]');
  const dots = hero.querySelectorAll('[data-go]');
  if (stage && dots.length) {
    let raf = null;
    stage.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        const w = stage.clientWidth;
        if (!w) return;
        const idx = Math.round(stage.scrollLeft / w);
        dots.forEach((d, i) => d.classList.toggle('alhv2__dot--active', i === idx));
      });
    }, { passive: true });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const idx = Number(dot.dataset.go) || 0;
        stage.scrollTo({ left: stage.clientWidth * idx, behavior: 'smooth' });
      });
    });
  }

  // Dynamic-island scroll trigger: fire as soon as the user scrolls past
  // the very top of the page, not after the whole hero clears the viewport.
  // On scroll, row 1 of the header gains a white bg (see allomoms-brand.css)
  // while row 2 (the wordmark pill) stays transparent — only the pill
  // floats over the page content.
  const onScroll = () => {
    document.body.classList.toggle('scrolled-past-hero', window.scrollY > 20);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
